import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  iconCheck: {
    color: theme.palette.success.light,
  },
  iconCancel: {
    color: theme.palette.error.light,
  },
}));

export default useStyles;
